// Path: ./src/utils/preference/cuisinePayload.ts
import {
  GfFlyerItemCategory,
  GfPreferenceCuisine,
} from "@swagger/typescript-fetch-goflyer";

export type CuisineRow = GfPreferenceCuisine & {
  categories?: GfFlyerItemCategory[];
};

export interface CuisineFormState {
  name: string;
  nameChinese: string;
  nameFrench: string;
  index: string;
  categoryIds: string[];
}

export const emptyCuisineFormState = (): CuisineFormState => ({
  name: "",
  nameChinese: "",
  nameFrench: "",
  index: "",
  categoryIds: [],
});

export const cuisineToFormState = (cuisine: CuisineRow): CuisineFormState => ({
  name: cuisine.name ?? "",
  nameChinese: cuisine.nameChinese ?? "",
  nameFrench: cuisine.nameFrench ?? "",
  index: cuisine.index == null ? "" : String(cuisine.index),
  categoryIds: (cuisine.categories ?? [])
    .map((category) => category.id)
    .filter((id): id is string => Boolean(id)),
});

const trimmedOrNull = (value: string): string | null =>
  value.trim() ? value.trim() : null;

const parsedIndexOrNull = (value: string): number | null => {
  if (!value.trim()) return null;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const buildCuisinePayload = (
  form: CuisineFormState,
  { isUpdate }: { isUpdate: boolean },
): Record<string, unknown> => {
  const payload: Record<string, unknown> = { name: form.name.trim() };

  const nameChinese = trimmedOrNull(form.nameChinese);
  const nameFrench = trimmedOrNull(form.nameFrench);
  const index = parsedIndexOrNull(form.index);

  if (isUpdate) {
    payload.nameChinese = nameChinese;
    payload.nameFrench = nameFrench;
    payload.index = index;
    payload.categories = form.categoryIds.map((id) => ({ id }));
    return payload;
  }

  if (nameChinese !== null) payload.nameChinese = nameChinese;
  if (nameFrench !== null) payload.nameFrench = nameFrench;
  if (index !== null) payload.index = index;
  if (form.categoryIds.length) {
    payload.categories = form.categoryIds.map((id) => ({ id }));
  }

  return payload;
};
